module.exports = __webpack_public_path__ + "img/premier-web_user-experience-research.c748709f.jpg";